import React, { type SyntheticEvent } from 'react';
import { Field } from '@atlaskit/form';
import SectionMessage from '@atlaskit/section-message';
import FieldTextArea from '@atlaskit/textarea';
import FieldText from '@atlaskit/textfield';
import { useIntl } from '@atlassian/jira-intl';
import type {
	FormError,
	FieldErrors,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import FieldGroup from '../../../../common/ui/field-group/index.tsx';
import messages from './messages.tsx';

type CreateCategoryFormProps = {
	isDisabled: boolean;
	formError?: FormError;
	fieldErrors?: FieldErrors;
	testId?: string;
	onChange: (field: string, value: string) => void;
	onSubmit: (e: SyntheticEvent<HTMLElement>) => void;
};

const CreateCategoryForm = (props: CreateCategoryFormProps) => {
	const { formatMessage } = useIntl();
	const { onSubmit, formError, fieldErrors, isDisabled = false, testId } = props;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const createOnChangeHandlerForField = (field: string) => (e: SyntheticEvent<any>) => {
		props.onChange(field, e.currentTarget.value);
	};

	const errorMessage = (field: string) =>
		fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;

	return (
		// @ts-expect-error - TS2322 - Type '{ children: (Element | undefined)[]; onSubmit: (e: SyntheticEvent<any, Event>) => void; disabled: boolean; }' is not assignable to type 'DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>'.
		<form onSubmit={onSubmit} disabled={isDisabled}>
			{formError && (
				<SectionMessage appearance="error" testId={testId && `${testId}--section-message`}>
					{formatMessage(formError.message)}
				</SectionMessage>
			)}

			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<p>{formatMessage(messages.helpText)}</p>
			<Field
				// @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
				error={errorMessage('name')}
				label={formatMessage(messages.nameFieldLabel)}
				isRequired
				name="name"
			>
				{({ fieldProps }) => (
					<FieldGroup error={errorMessage('name')}>
						<FieldText
							{...fieldProps}
							isRequired
							autoComplete="off"
							placeholder={formatMessage(messages.nameFieldPlaceholder)}
							isInvalid={fieldErrors && !!fieldErrors.name}
							maxLength={100}
							onChange={createOnChangeHandlerForField('name')}
							isDisabled={isDisabled}
							autoFocus
						/>
					</FieldGroup>
				)}
			</Field>

			<Field
				// @ts-expect-error - TS2322 - Type '{ children: ({ fieldProps }: { fieldProps: FieldProps<string, HTMLInputElement>; error?: string | undefined; valid: boolean; meta: Meta; }) => Element; error: string | undefined; label: string; isRequired: true; name: string; }' is not assignable to type 'IntrinsicAttributes & FieldComponentProps<string, HTMLInputElement>'.
				error={errorMessage('description')}
				label={formatMessage(messages.descriptionFieldLabel)}
				name="description"
			>
				{({ fieldProps }) => (
					<FieldGroup error={errorMessage('description')}>
						<FieldTextArea
							{...fieldProps}
							maxLength={150}
							minimumRows={3}
							autoComplete="off"
							placeholder={formatMessage(messages.descriptionFieldPlaceholder)}
							isInvalid={fieldErrors && !!fieldErrors.description}
							isDisabled={isDisabled}
							onChange={createOnChangeHandlerForField('description')}
						/>
					</FieldGroup>
				)}
			</Field>
		</form>
	);
};

export default CreateCategoryForm;
